export module DateUtil {
    export function parseDateToTimestamp(date: Date): number {
        if (date == null) {
            throw Error("The argument target is null or undefined");
        }
        return date.getTime();
    }

    export function parseTimeStampToDate(timeStamp: number) {
        return new Date(timeStamp);
    }

    export function parseTimeStampToDateString(timeStamp: number) {
        return new Date(timeStamp).toLocaleDateString();
    }

    export function parseLocalDateTimeToString(localDateTime: LocalDateTime): string {
        if (!localDateTime || localDateTime.length <= 0) {
            return '';
        }
        return new Date(...localDateTime).toLocaleDateString();
    }

    export function parseLocalDateTimeToDate(localDateTime: LocalDateTime) {
        return new Date(...localDateTime);
    }

    export function toStartOfDay(date:Date):Date{
        const result = new Date(date);
        result.setHours(0, 0, 0);
        return result;
    }

    export function toEndOfDay(date: Date): Date {
        const result = new Date(date);
        result.setHours(23, 59, 59);
        return result;
    }

    export function parseDateToLocalDateTime(date: Date): LocalDateTime {
        return [date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()];
    }

    export function greaterThanToday(){

    }

    export function lessThanToday(){
        
    }
}
export type LocalDateTime = [number,// year
    number,// month
    number,// date
    number,// hours
    number,// mins
    number,// seconds
    number];// milliseconds